import * as React from 'react'

import type { Form } from 'factorial-form'
import groupBy from 'lodash/groupBy'
import mapValues from 'lodash/mapValues'
import sortBy from 'lodash/sortBy'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/Inputs/DayPicker'
import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

interface Event {
  category: string
  event_name: string
  translated_event_name: string
}

interface OptionsProps {
  filtersForm: Form
  onChildPopoverOpen?: React.Dispatch<React.SetStateAction<boolean>>
  eventList: Event[]
}

const Options = ({ filtersForm, onChildPopoverOpen, eventList }: OptionsProps) => {
  const optionsEvents = mapValues(
    groupBy(eventList, (item) => item.category),
    (events) =>
      events.map((item) => ({
        value: item.event_name,
        label: item.translated_event_name,
      }))
  )

  const sortedUsers = sortBy(users.toArray(), (user) => user.fullName())
  const optionsUsers = sortedUsers.map((user) => ({
    value: user.id,
    label: user.fullName(),
  }))

  return (
    <>
      <Select
        label={i18n.t('settings.audit_log.filters.event_name')}
        field={filtersForm.get('event_type')}
        options={optionsEvents}
        none={i18n.t('filters.filter.none')}
      />
      <Select
        label={i18n.t('settings.audit_log.filters.author_name')}
        field={filtersForm.get('access_id')}
        options={optionsUsers}
        none={i18n.t('filters.filter.none')}
      />
      <DayPicker
        withNull
        label={i18n.t('settings.audit_log.filters.date_from')}
        field={filtersForm.get('date_from')}
        onToggle={onChildPopoverOpen}
        readonlyValue={i18n.t('settings.audit_log.no_start_date_value')}
        withNullLabel={i18n.t('settings.audit_log.no_start_date')}
      />
      <DayPicker
        withNull
        label={i18n.t('settings.audit_log.filters.date_to')}
        field={filtersForm.get('date_to')}
        onToggle={onChildPopoverOpen}
        readonlyValue={i18n.t('settings.audit_log.no_end_date_value')}
        withNullLabel={i18n.t('settings.audit_log.no_end_date')}
      />
    </>
  )
}

export default observer(Options)
